import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface AddCustomScheduleColumnDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateCustomScheduleColumn: (header: string) => Promise<void>;
}

export function AddCustomScheduleColumnDialog({
  open,
  onOpenChange,
  onCreateCustomScheduleColumn,
}: AddCustomScheduleColumnDialogProps) {
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      toast.error("Column name is required");
      return;
    }

    setIsSaving(true);
    try {
      await onCreateCustomScheduleColumn(trimmedName);
      setName("");
      onOpenChange(false);
    } catch {
      // onCreateCustomScheduleColumn reports the failure.
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!isSaving) {
          onOpenChange(nextOpen);
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Column</DialogTitle>
          <DialogDescription>
            Create a custom column that can be filled in from the takeoff results table.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-sm font-medium" htmlFor="custom-schedule-column-name">
            Column Name
          </label>
          <Input
            id="custom-schedule-column-name"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Install Notes"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSaving}>
            Cancel
          </Button>
          <Button onClick={() => void handleSubmit()} disabled={isSaving}>
            Save Column
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
